var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "6"
                          }
                        },
                        [_vm._v(" Your Affiliate Payments ")]
                      ),
                      !_vm.forPrint
                        ? _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "6"
                              }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "mx-4",
                                attrs: {
                                  label: "Search",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": ""
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function callback($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.payments,
                      "sort-by": "month",
                      "sort-desc": "",
                      search: _vm.search,
                      "disable-pagination": _vm.forPrint,
                      "hide-default-footer": _vm.forPrint,
                      loading: _vm.pending
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }